<template>
    <div
        style="height: 100vh; display: flex; flex-direction: column; overflow-y: scroll;"
    >
        <v-card id="details" :loading="loading" style="flex-grow: 1;">
            <v-card-title ref="title" class="sticky-header">
                <v-btn small icon @click="close" color="primary" class="mr-2">
                    <v-icon>
                        mdi-close
                    </v-icon>
                </v-btn>
                <h3>
                    {{ 'Foreign Trade Module' }}
                </h3>
                <v-btn
                    v-if="!view"
                    @click="print"
                    small
                    icon
                    color="primary"
                    class="ml-2"
                >
                    <v-icon> mdi-file-pdf-box </v-icon>
                </v-btn>
                <v-btn
                    v-if="view"
                    @click="showCOMEXFile"
                    small
                    icon
                    color="primary"
                    class="ml-2"
                >
                    <v-icon> mdi-file-pdf-box </v-icon>
                </v-btn>

                <v-spacer />
                <v-btn
                    rounded
                    v-if="!view"
                    :loading="loading2"
                    color="primary"
                    class="mx-2"
                    :disabled="!validateGeneralForm"
                    @click="saveComexForm"
                >
                    SAVE
                </v-btn>
            </v-card-title>
            <v-divider class="ml-4 mr-5" />
            <v-card-text class="pt-0">
                <v-form v-model="valid" class="py-2">
                    <v-row no-gutters class="mt-4">
                        <v-col
                            cols="12"
                            xl="3"
                            lg="3"
                            md="3"
                            sm="6"
                            class="pl-2"
                        >
                            <v-text-field
                                disabled
                                :value="formattedSuppliers"
                                prepend-icon="mdi-store"
                                label="Suppliers"
                                hide-details
                                readonly
                            />
                        </v-col>

                        <v-col
                            cols="12"
                            xl="3"
                            lg="3"
                            md="3"
                            sm="6"
                            class="pl-2"
                        >
                            <v-text-field
                                disabled
                                v-model="request.number"
                                prepend-icon="mdi-import"
                                label="Importation Number"
                                readonly
                                hide-details
                            />
                        </v-col>

                        <v-col
                            cols="12"
                            xl="3"
                            lg="3"
                            md="3"
                            sm="6"
                            class="pl-2"
                        >
                            <v-text-field
                                disabled
                                v-model="request.project.name"
                                prepend-icon="mdi-head-lightbulb"
                                label="Project"
                                readonly
                                hide-details
                            />
                        </v-col>
                        <v-col
                            cols="12"
                            xl="3"
                            lg="3"
                            md="3"
                            sm="6"
                            class="pl-2"
                        >
                            <v-text-field
                                disabled
                                v-model="formattedYear"
                                prepend-icon="mdi-calendar-blank"
                                label="Year"
                                readonly
                                hide-details
                            />
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="mt-4">
                        <v-col
                            cols="12"
                            xl="3"
                            lg="3"
                            md="3"
                            sm="4"
                            class="pl-2"
                        >
                            <v-autocomplete
                                :disabled="view"
                                v-model="request.originCountry"
                                :items="this.countries"
                                prepend-icon="mdi-earth"
                                :rules="[rules.required]"
                                label="Country of origin"
                                @change="selectState"
                            />
                        </v-col>
                        <v-col
                            cols="12"
                            xl="3"
                            lg="3"
                            md="3"
                            sm="6"
                            class="pl-2"
                        >
                            <v-autocomplete
                                :disabled="view"
                                v-model="request.originState"
                                @change="selectCity"
                                :items="this.states"
                                :rules="[rules.required]"
                                prepend-icon="mdi-map-marker-radius"
                                label="State of origin"
                            />
                        </v-col>
                        <v-col
                            cols="12"
                            xl="3"
                            lg="3"
                            md="3"
                            sm="6"
                            class="pl-2"
                        >
                            <v-combobox
                                :disabled="view"
                                v-model="request.originCity"
                                :items="this.cities"
                                label="City of origin"
                                placeholder="Select or create one"
                                :rules="[rules.required]"
                                hide-details
                                prepend-icon="mdi-city"
                                hide-selected
                            >
                            </v-combobox>
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="my-1 mt-0">
                        <v-col
                            cols="12"
                            xl="3"
                            lg="3"
                            md="3"
                            sm="6"
                            class="pl-2"
                        >
                            <v-select
                                :disabled="view"
                                v-model="request.incoterm"
                                :items="formattedIncoterms"
                                label="Select a incoterm"
                                item-text="text"
                                item-value="value"
                                hide-details
                                prepend-icon="mdi-receipt-text-check-outline"
                                hide-selected
                                :rules="[rules.required]"
                                :menu-props="{ bottom: true, offsetY: true }"
                            />
                        </v-col>
                        <v-col
                            cols="12"
                            xl="3"
                            lg="3"
                            md="3"
                            sm="6"
                            class="pl-2"
                        >
                            <v-select
                                :disabled="view"
                                v-model="request.modality"
                                :items="comexData.modality"
                                label="Select a modality"
                                hide-details
                                prepend-icon="mdi-receipt-text-outline"
                                hide-selected
                                :rules="[rules.required]"
                                :menu-props="{ bottom: true, offsetY: true }"
                            />
                        </v-col>
                        <v-col
                            v-if="hasPlanVallejo"
                            cols="12"
                            xl="3"
                            lg="3"
                            md="3"
                            sm="6"
                            class="pl-2"
                        >
                            <v-menu
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                                v-model="menu3"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        :disabled="view"
                                        v-model="request.maxExpDate"
                                        :rules="[rules.required]"
                                        label="Max Export Date"
                                        prepend-icon="mdi-receipt-text-clock-outline"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                        hide-details
                                        class="pl-2"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="request.maxExpDate"
                                    @input="menu3 = false"
                                ></v-date-picker>
                            </v-menu>
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="mt-4">
                        <v-col cols="12" class="pl-2">
                            <v-textarea
                                :disabled="view"
                                v-model="request.comexNotes"
                                rows="1"
                                auto-grow
                                hide-details
                                label="Notes"
                                prepend-icon="mdi-text"
                            />
                        </v-col>
                    </v-row>
                </v-form>
                <v-row>
                    <v-spacer />
                    <v-btn
                        v-if="!view"
                        rounded
                        color="primary"
                        class="mt-4 mr-3 white--text"
                        hide-details
                        @click="openImportFromForm"
                    >
                        import from form
                    </v-btn>
                    <v-btn
                        v-if="!view"
                        rounded
                        color="primary"
                        class="mt-4 mr-3 white--text"
                        hide-details
                        @click="createShipmentForm"
                        :disabled="validateNewShipment === 0"
                    >
                        create a shipment
                    </v-btn>
                </v-row>
                <v-data-table
                    class="elevation-2 mt-6"
                    :headers="headers"
                    :items="request.items"
                    :loading="loading"
                    :mobile-breakpoint="0"
                    disable-pagination
                    hide-default-footer
                    fixed-header
                >
                    <template v-slot:top>
                        <v-row
                            no-gutter
                            class="pa-0 ma-0"
                            :style="{ 'background-color': '#eeeeee' }"
                        >
                            <v-col cols="12" class="d-flex">
                                <p class="text-h5 my-0 pl-3 font-weight-bold">
                                    Received Items
                                </p>
                            </v-col>
                        </v-row>
                    </template>
                    <!--ITEMS-->
                    <template v-slot:[`item.index`]="{ index }">
                        <p class="mt-3 font-weight-medium">
                            {{ index + 1 }}
                        </p>
                    </template>
                    <template v-slot:[`item.code`]="{ item }">
                        <p class="mt-3 font-weight-medium">
                            {{ item.code }}
                        </p>
                    </template>
                    <template v-slot:[`item.description`]="{ item }">
                        <p class="mt-3 font-weight-medium">
                            {{ item.description }}
                        </p>
                    </template>
                    <template v-slot:[`item.quantity`]="{ item }">
                        <p class="mt-3 font-weight-medium">
                            {{ item.quantity }}
                        </p>
                    </template>
                    <template v-slot:[`item.received`]="{ item }">
                        <p :class="validateItemQty(item)">
                            {{ getReceived()(item.code) }}
                        </p>
                    </template>
                    <template v-slot:[`item.processed`]="{ item }">
                        <p :class="validateItemProcessed(item.code)">
                            {{ getProcessed()(item.code) }}
                        </p>
                    </template>
                    <template v-slot:[`item.supplier`]="{ item }">
                        <p class="my-0 text-capitalize font-weight-medium">
                            {{ getSupplier(item) }}
                        </p>
                    </template>
                    <template v-slot:[`item.order`]="{ item }">
                        <a
                            v-if="item.purchaseOrder && item.purchaseOrder.file"
                            @click="handleOpenFile(item)"
                            >{{ item.purchaseOrder.orderNumber }}</a
                        >
                        <p v-else class="font-weight-medium my-0">
                            {{
                                item.purchaseOrder
                                    ? item.purchaseOrder.orderNumber
                                    : ''
                            }}
                        </p>
                    </template>
                    <template v-slot:[`item.price`]="{ item }">
                        <p class="font-weight-medium mt-3" v-if="item.quotes">
                            {{
                                numberFormat(
                                    calculatePrice(item),
                                    quoteCurrency(item)
                                )
                            }}
                        </p>
                    </template>
                    <template v-slot:[`item.totalPrice`]="{ item }">
                        <p class="font-weight-medium mt-3" v-if="item.quotes">
                            {{
                                numberFormat(
                                    calculateItemTotal(item),
                                    quoteCurrency(item)
                                )
                            }}
                        </p>
                    </template>
                    <!-- FOOTER -->
                    <template v-slot:[`body.append`]>
                        <tr :style="{ 'background-color': '#eeeeee' }">
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td class="font-weight-bold">
                                <p
                                    class="d-flex justify-center align-right my-0"
                                >
                                    TOTAL:
                                </p>
                            </td>
                            <td class="font-weight-bold">
                                <p
                                    class="d-flex justify-center align-right my-0"
                                >
                                    {{
                                        numberFormat(
                                            calculateTotal(),
                                            purchaseCurrency()
                                        )
                                    }}
                                </p>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
                <v-spacer></v-spacer>
                <ComexShipmentForm
                    ref="shipmentForms"
                    class="mt-4 elevation-1"
                    v-for="shipment in shipments"
                    :key="shipment.id + '-' + shipmentKey"
                    :newShipment="shipment.newShipment"
                    :isEditable="shipment.editable"
                    :iterator="shipment.iterator"
                    :shipmentId="shipment.id"
                    :request="request"
                    :items="shipment.items"
                    :maxValues="itemValues"
                    :view="view"
                    :validateNewShipment="validateNewShipment"
                    :formShipment="shipment.shipmentFormData"
                    :itemsInRequest="itemsStructureData() || []"
                    @deleteShipment="deleteShipment"
                    @deleteFile="deleteFile"
                    @openFile="openAttachedFile"
                    @comexShipment="comexShipment"
                />
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn
                    v-if="!view"
                    color="primary"
                    rounded
                    class="mt-n2 mr-3 white--text"
                    :loading="loading"
                    @click="finalVerification"
                    :disabled="
                        validateGeneralForm ||
                            (request.status != 'received' &&
                                request.status != 'closed' &&
                                request.status != 'readyToClose')
                    "
                >
                    Finalize COMEX
                </v-btn>
            </v-card-actions>
        </v-card>
        <v-dialog
            :retain-focus="false"
            :loading="loading"
            persistent
            max-width="1350px"
            v-model="importFromForm"
        >
            <v-card>
                <v-card-title class="text-h5">
                    <v-btn
                        small
                        icon
                        @click="closeImportFromForm"
                        color="primary"
                        class="mr-2"
                    >
                        <v-icon>
                            mdi-close
                        </v-icon>
                    </v-btn>
                    <h3>{{ 'Import from Another Form' }}</h3>
                </v-card-title>
                <v-divider class="ml-4 mr-5" />
                <v-card-text>
                    <v-row class="mt-4 ml-5 mr-5">
                        <p>
                            Select the purchase from which you want to import
                            the information.
                        </p>
                    </v-row>
                    <v-row class="mt-4 ml-5 mb-4 mr-5">
                        <v-autocomplete
                            prepend-icon="mdi-text-box-search-outline"
                            label="Source Purchase"
                            v-model="importedInformation"
                            :items="purchasesForImport"
                            item-text="number"
                            return-object
                            class="ma-0 pa-0"
                        />
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        color="primary mt-n3 mb-2 mr-2"
                        rounded
                        @click="importInformationProcess"
                    >
                        SAVE
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            :retain-focus="false"
            :loading="loading"
            persistent
            max-width="500px"
            v-model="finalVerificationView"
        >
            <v-card>
                <v-card-title class="text-h5">
                    <h3>{{ 'Are you sure you want to continue?' }}</h3>
                </v-card-title>
                <v-divider class="ml-4 mr-4" />
                <v-card-text>
                    <v-row class="mt-4 ml-4 mr-4">
                        <p>
                            {{
                                'It has been detected that the values purchased, received, and processed have inconsistencies; are you sure you want to finalize the import?'
                            }}
                        </p>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        color="primary mt-n3 mb-2 ml-2 mr-2"
                        @click="closefinalVerificationView"
                    >
                        CANCEL
                    </v-btn>
                    <v-spacer />
                    <v-btn
                        color="error"
                        class="mt-n3 mb-2 mr-2"
                        @click="finalizeComex"
                    >
                        CONTINUE
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import { deleteFile } from '@/services/storage/deleteFile.js'
import { saveFile } from '@/services/storage/saveFile.js'
import { openFile } from '@/services/storage/openFile.js'
import { mapMutations } from 'vuex'
import { printCOMEXPDF } from './ComexPDF'
import {
    findAbleQuote,
    isCopQuote,
    quoteDisplayCurrency,
    quoteUsdUnitPrice,
} from './comexUsd'
import { storage } from '@/services/firebase'
import { objDiff } from '@/helpers/objDiff.js'
import _ from 'lodash'
import API from '@/services/api'
import ComexShipmentForm from '@/components/Comex/ComexShipmentForm.vue'
const countrycitystate = require('countrycitystatejson')
const { v4: uuidv4 } = require('uuid')

export default {
    name: 'ComexForm',
    components: {
        ComexShipmentForm,
    },
    props: {
        purchase: {
            type: Object,
            default: () => ({ type: 'material', items: [] }),
            required: true,
        },
        view: {
            type: Boolean,
            default: () => false,
        },
    },
    data: () => ({
        loading: false,
        loading2: false,
        valid: false,
        menu3: false,
        rules: {
            required: v => !!v || 'Required',
            number2: v => v > 0 || 'Error',
            number: v => v >= 0 || 'Error',
            optionalNumber: v => !v || v == '' || v > 0 || 'Invalid number',
            validateNumber: v => {
                const numberValue = parseFloat(v)
                return (
                    (!isNaN(numberValue) && numberValue > 0) || 'Invalid number'
                )
            },
        },
        comexData: {
            incoterms: {
                'Ex Works': 'EXW',
                'Free Carrier': 'FCA',
                'Free Alongside Ship': 'FAS',
                'Free On Board': 'FOB',
                'Cost And Freight': 'CFR',
                'Cost, Insurance, and Freight': 'CIF',
                'Carriage Paid To': 'CPT',
                'Carriage Insurance Paid To': 'CIP',
                'Delivered at Terminal': 'DAT',
                'Delivered at Place': 'DAP',
                'Delivered Duty Paid': 'DDP',
            },
            modality: ['Plan Vallejo', 'Courier', 'Ordinary'],
        },
        countries: [],
        cities: [],
        states: [],
        headers: [
            {
                text: 'INDEX',
                value: 'index',
                align: 'center',
                sortable: false,
                width: '95',
            },
            {
                text: 'CODE',
                value: 'code',
                align: 'center',
                sortable: false,
                width: '120',
            },
            {
                text: 'ORDER',
                value: 'order',
                align: 'center',
                sortable: false,
                width: '120',
            },
            {
                text: 'ITEM',
                value: 'description',
                align: 'left',
                sortable: false,
            },
            {
                text: 'SUPPLIER',
                value: 'supplier',
                align: 'left',
                sortable: false,
            },
            {
                text: 'PURCHASED',
                value: 'quantity',
                align: 'center',
                sortable: false,
                width: '95',
            },
            {
                text: 'RECEIVED',
                value: 'received',
                align: 'center',
                sortable: false,
                width: '95',
            },
            {
                text: 'PROCESSED',
                value: 'processed',
                align: 'center',
                sortable: false,
                width: '95',
            },
            {
                text: 'PRICE',
                value: 'price',
                align: 'center',
                sortable: false,
            },
            {
                text: 'TOTAL',
                value: 'totalPrice',
                align: 'center',
                sortable: false,
            },
        ],
        listCountries: [],
        shortNameCity: null,
        suppliers: new Set(),
        shipmentForm: false,
        shipments: [],
        originalrequest: {},
        request: { project: { name: '' }, suppliers: [] },
        companyId: JSON.parse(localStorage.getItem('company')),
        itemValues: [],
        shipmentKey: 0,
        localAttachments: { files: {} },
        user: {},
        importFromForm: false,
        importedInformation: null,
        purchasesForImport: null,
        finalVerificationView: false,
    }),
    computed: {
        formattedIncoterms() {
            return Object.entries(this.comexData.incoterms).map(
                ([key, value]) => ({
                    text: `(${value}) ${key}`,
                    value,
                })
            )
        },
        formattedYear() {
            let timestamp

            if (
                typeof this.request.purchasedDate === 'object' &&
                '_seconds' in this.request.purchasedDate
            ) {
                timestamp = this.request.purchasedDate._seconds * 1000
            } else if (
                typeof this.request.purchasedDate === 'object' &&
                'seconds' in this.request.purchasedDate
            ) {
                timestamp = this.request.purchasedDate.seconds * 1000
            } else {
                return 'Invalid Date'
            }
            const date = new Date(timestamp)
            return date.getFullYear()
        },
        formattedSuppliers() {
            const suppliers = this.request.suppliers
            if (Array.isArray(suppliers)) {
                return suppliers.join(', ')
            }
            return suppliers || ''
        },
        validateGeneralForm: function() {
            let diff = objDiff(this.originalrequest, this.request)
            delete diff.year
            delete diff.suppliers
            return Object.keys(diff).length > 0
        },
        hasPlanVallejo() {
            if (this.request?.modality === 'Plan Vallejo') return true
            const comex = this.request?.comex || []
            return comex.some(
                item =>
                    (item.modality || this.request.modality) === 'Plan Vallejo'
            )
        },
        getReceived() {
            return () => {
                const items = this.request?.items || []
                let received = []

                items.forEach(item => {
                    if (item.entries) {
                        const code = item.code
                        let quantityReceived = item.entries.reduce(
                            (sum, entry) => sum + entry.quantity,
                            0
                        )
                        received.push({ code, quantityReceived })
                    }
                })

                return id => {
                    const item = received.find(obj => obj.code === id)
                    return item ? item.quantityReceived : 0
                }
            }
        },
        getProcessed() {
            return () => {
                const items = []
                const comex = this.request?.comex || []
                comex.forEach(obj => {
                    if (obj.items) {
                        items.push(...obj.items)
                    }
                })
                let processed = []

                items.forEach(item => {
                    const code = item.code
                    const quantityProcessed = item.quantity

                    const processedIndex = processed.findIndex(
                        obj1 => obj1.code === code
                    )
                    if (processedIndex > -1) {
                        processed[
                            processedIndex
                        ].quantityProcessed += quantityProcessed
                    } else {
                        processed.push({ code, quantityProcessed })
                    }
                })

                return id => {
                    const item = processed.find(obj => obj.code === id)
                    return item ? item.quantityProcessed : 0
                }
            }
        },
        validateNewShipment() {
            const validate = this.itemValues.reduce((accum, obj) => {
                return accum + (obj.maxValue || 0)
            }, 0)
            return validate
        },
        validateFinalizeCOMEX() {
            let numberItems = this.request.items.length
            this.request.items.forEach(item => {
                if (this.getReceived()(item.code) === 0) {
                    return false
                } else if (
                    this.getReceived()(item.code) -
                        this.getProcessed()(item.code) ===
                    0
                ) {
                    numberItems -= 1
                }
            })
            return numberItems === 0
        },
    },
    async mounted() {
        try {
            this.loading = true
            const {
                data: { user },
            } = await API.getMyInfo()
            this.user = user
            this.originalrequest = _.cloneDeep(this.purchase)
            this.request = _.cloneDeep(this.purchase)
            if (!this.purchase.comex) {
                this.originalrequest.comex = []
                this.request.comex = []
            }
            this.itemsMaxValues()
            this.getSuppliers()
            this.request.suppliers = [...this.suppliers]
            this.request.year = this.formattedYear
            this.listCountries = countrycitystate.getCountries()
            this.countries = this.listCountries.map(x => x?.name)
            if (this.request.originCountry) {
                this.selectState(this.request.originCountry)
            }

            if (this.request.originState) {
                this.selectCity(this.request.originState)
            }
            await this.getShipments()
        } catch (error) {
            this.setErrorItems({
                source: this.$options.name,
                message: error.message,
            })
        } finally {
            this.loading = false
        }
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        close() {
            this.$emit('close')
        },
        async saveComexForm() {
            try {
                this.loading2 = true
                this.flushShipmentForms()
                await this.$nextTick()
                let comexData = _.cloneDeep(this.request)
                delete comexData.year
                delete comexData.suppliers
                if (!this.hasPlanVallejo && comexData.maxExpDate) {
                    delete comexData.maxExpDate
                }
                const diff = objDiff(this.originalrequest, comexData)
                diff.id = this.request.id
                if (diff.comex) {
                    diff.comex = this.request.comex.map(item => {
                        const cleaned = { ...item }
                        delete cleaned.editable
                        return cleaned
                    })
                }
                if (this.hasPendingAttachmentChanges()) {
                    await this.saveAttachments()
                }
                await API.updatePurchaseByComex(diff)
                this.originalrequest = _.cloneDeep(this.request)
                await this.getShipments()
                this.shipmentKey++
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading2 = false
            }
        },
        selectState: function(event) {
            const index = this.listCountries.findIndex(x => x?.name === event)
            this.shortNameCity = this.listCountries[index].shortName
            this.states = countrycitystate.getStatesByShort(this.shortNameCity)
        },
        selectCity: function(event) {
            let data = countrycitystate.getCities(this.shortNameCity, event)
            if (data.length == 0) {
                this.cities = []
            }
            data.forEach(city => {
                this.cities.push(city)
            })
        },
        validateItemQty(item) {
            let entryQty = 0
            if (item.entries && item.entries.length > 0) {
                entryQty = item.entries.reduce(
                    (accumulator, entry) => entry.quantity + accumulator,
                    0
                )
            }
            if (entryQty >= item.quantity) {
                return 'mt-3 font-weight-medium green--text'
            } else if (entryQty == 0) {
                return 'mt-3 font-weight-medium red--text'
            } else {
                return 'mt-3 font-weight-medium orange--text'
            }
        },
        validateItemProcessed(code) {
            if (this.getReceived()(code) < this.getProcessed()(code)) {
                return 'mt-3 font-weight-medium red--text'
            } else if (this.getReceived()(code) == this.getProcessed()(code)) {
                return 'mt-3 font-weight-medium green--text'
            } else if (this.getProcessed()(code) == 0) {
                return 'mt-3 font-weight-medium red--text'
            } else {
                return 'mt-3 font-weight-medium orange--text'
            }
        },
        quoteCurrency(item) {
            return quoteDisplayCurrency(findAbleQuote({ items: [item] }, item))
        },
        purchaseCurrency() {
            const currencies = (this.request.items || []).map(item =>
                this.quoteCurrency(item)
            )
            if (
                currencies.length > 0 &&
                currencies.every(currency => currency === currencies[0])
            ) {
                return currencies[0]
            }
            return 'USD'
        },
        numberFormat(amount, currency = 'USD') {
            const digits = currency === 'COP' ? 0 : 2
            return new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency,
                minimumFractionDigits: digits,
                maximumFractionDigits: digits,
            }).format(amount)
        },
        getSupplier(item) {
            const selectedQuote = item.quotes?.find(quote => quote.able)
            return selectedQuote ? selectedQuote.supplier?.name : undefined
        },
        finalVerification() {
            try {
                if (!this.validateFinalizeCOMEX) {
                    this.finalVerificationView = true
                } else {
                    this.finalizeComex()
                }
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            }
        },
        closefinalVerificationView() {
            this.finalVerificationView = false
        },
        async finalizeComex() {
            try {
                this.loading2 = true
                this.loading = true
                this.finalVerificationView = false
                const { pdf } = await this.print()
                const fileName = `ForeignTrade_${this.request.number}`
                let pdfFile = this.blobToFile(pdf, fileName)
                const request = this.request
                await saveFile(
                    pdfFile,
                    `${this.companyId}/purchases/${this.request.id}/AttachmentsCOMEX/COMEX`
                )
                await API.updatePurchaseByComex({
                    comexFinished: true,
                    attachedCOMEX: pdfFile.name,
                    id: this.request.id,
                })
                if (request.status == 'closed') {
                    await this.closeByCOMEX(request)
                } else {
                    this.$emit('finalize-comex', this.request.id)
                }
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading2 = false
                this.loading = false
            }
        },
        getSuppliers() {
            if (
                this.request.items &&
                Array.isArray(this.request.items) &&
                this.request.items.length > 0
            ) {
                this.request.items.forEach(item => {
                    if (
                        item.quotes &&
                        Array.isArray(item.quotes) &&
                        item.quotes.length > 0
                    ) {
                        item.quotes.forEach(quote => {
                            if (
                                quote.able === true &&
                                quote.supplier &&
                                quote.supplier.name
                            ) {
                                this.suppliers.add(quote.supplier.name)
                            }
                        })
                    }
                })
            }
        },
        createShipmentForm() {
            let shipment = {}
            shipment.id = uuidv4().substring(0, 4)
            shipment.editable = true
            shipment.newShipment = true
            shipment.items = this.itemsStructureData()
            shipment.iterator = this.shipments.length + 1
            this.shipments.push(shipment)
        },
        itemsStructureData() {
            const codes = this.getCodesOfPurchaseItems()
            let itemsSelected = []
            codes.forEach(code => {
                const received = this.getReceived()(code)
                const processed = this.getProcessed()(code)
                if (received != 0 && processed < received) {
                    const purchaseItem = this.request.items.find(
                        item => item.code === code
                    )
                    const supplier = purchaseItem.quotes.find(
                        quote => quote.able === true
                    )
                    const shipmentItem = {
                        code,
                        oc: purchaseItem.purchaseOrder?.orderNumber || '',
                        description: purchaseItem.description,
                        quantity: 0,
                        id: purchaseItem.id,
                        supplier: supplier.supplier,
                        unitPrice: isCopQuote(supplier)
                            ? 0
                            : quoteUsdUnitPrice(supplier) ??
                              (Number(supplier.price) || 0),
                        totalPrice: 0,
                    }

                    itemsSelected.push(shipmentItem)
                }
            })
            return itemsSelected
        },
        itemsMaxValues() {
            this.itemValues = []
            this.request.items.forEach(obj => {
                const received = this.getReceived()(obj.code)
                const processed = this.getProcessed()(obj.code)
                let maxValue = 0
                if (received - processed > 0) {
                    maxValue = received - processed
                }
                this.itemValues.push({
                    code: obj.code,
                    description: obj.description,
                    maxValue,
                    received: received,
                    processed: processed,
                })
            })
        },
        getCodesOfPurchaseItems() {
            let codesItems = []
            this.request.items.forEach(item => {
                codesItems.push(item.code)
            })
            return codesItems
        },
        async getOrderURL(item) {
            const path = `${this.companyId}/purchases/${this.request.id}/purchase_order`
            const storageRef = await storage().ref(path)
            const docRef = storageRef.child(item.purchaseOrder.file)

            try {
                item.purchaseOrder.fileURL = await docRef.getDownloadURL()
            } catch (error) {
                console.error('Error al obtener la URL de descarga:', error)
                item.purchaseOrder.fileURL = null
            }
            return item.purchaseOrder.fileURL
        },
        openFile(url) {
            window.open(url, '_blank')
        },
        async print() {
            try {
                this.loading = true
                const pdf = await printCOMEXPDF(
                    this.request,
                    this.formattedSuppliers,
                    this.formattedYear
                )
                return { pdf }
            } catch (error) {
                console.error(error)
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        deleteShipment(shipmentId) {
            const index = this.shipments.findIndex(
                item => item.id === shipmentId
            )
            if (index > -1) {
                this.shipments.splice(index, 1)
                const comexIndex = this.request.comex.findIndex(
                    obj => obj.id === shipmentId
                )
                if (comexIndex > -1) {
                    this.request.comex.splice(comexIndex, 1)
                }
            }
            this.itemsMaxValues()
        },
        getAttachmentsStoragePath() {
            return `${this.companyId}/purchases/${this.request.id}/AttachmentsCOMEX`
        },
        hasPendingAttachmentChanges() {
            const pendingUploads =
                this.localAttachments.files &&
                Object.keys(this.localAttachments.files).length > 0
            return pendingUploads
        },
        mergeLocalAttachments(attachments) {
            if (!attachments || typeof attachments !== 'object') return
            Object.keys(attachments).forEach(key => {
                if (!this.localAttachments[key]) {
                    this.$set(this.localAttachments, key, {})
                }
                Object.assign(
                    this.localAttachments[key],
                    attachments[key] || {}
                )
            })
        },
        async deleteFileFromStorage(fileName) {
            const basePath = this.getAttachmentsStoragePath()
            const paths = [basePath, `${basePath}/files`]

            for (const path of paths) {
                try {
                    const storageRef = storage().ref(path)
                    const result = await storageRef.listAll()
                    const fileNames = result.items.map(item => item.name)
                    if (fileNames.includes(fileName)) {
                        await deleteFile(fileName, path)
                        return
                    }
                } catch (error) {
                    console.warn('Error checking attachment folder:', error)
                }
            }
        },
        async deleteFile(file) {
            await this.deleteFileFromStorage(file)
        },
        async saveAttachments() {
            try {
                this.loading = true
                const basePath = this.getAttachmentsStoragePath()
                const files = this.localAttachments.files || {}

                for (const fileData of Object.values(files)) {
                    await saveFile(fileData.file, `${basePath}/files`)
                }

                this.localAttachments = { files: {} }
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        async openAttachedFile(file) {
            const fileName = typeof file === 'string' ? file : file.name
            const basePath = this.getAttachmentsStoragePath()
            const url = await openFile(fileName, basePath)
            if (!url) {
                await openFile(fileName, `${basePath}/files`)
            }
        },
        flushShipmentForms() {
            const forms = []
                .concat(this.$refs.shipmentForms || [])
                .filter(form => form && typeof form.structureData === 'function')
            forms.forEach(form => form.structureData())
        },
        comexShipment(data, items, attachments) {
            const newComex = [...this.request.comex]
            const indexComex = newComex.findIndex(item => item.id === data.id)
            if (indexComex > -1) {
                newComex.splice(indexComex, 1, {
                    ...data,
                    items: [...items],
                })
            } else {
                newComex.push({ ...data, items: [...items] })
            }
            this.request = { ...this.request, comex: newComex }

            const shipmentIndex = this.shipments.findIndex(
                s => s.id === data.id
            )
            if (shipmentIndex > -1) {
                this.$set(
                    this.shipments[shipmentIndex],
                    'shipmentFormData',
                    _.omit(data, ['items'])
                )
            }

            this.mergeLocalAttachments(attachments)
            this.itemsMaxValues()
        },
        async handleOpenFile(item) {
            try {
                const fileURL =
                    item.purchaseOrder.fileURL || (await this.getOrderURL(item))
                if (fileURL) {
                    this.openFile(fileURL)
                } else {
                    console.warn('File URL not found.')
                }
            } catch (error) {
                console.error('Error getting file URL: ', error)
            }
        },
        async getShipments() {
            this.shipments.splice(0, this.shipments.length)
            const comex = Array.isArray(this.request.comex)
                ? this.request.comex
                : []
            if (comex.length > 0) {
                let iterator = 0
                comex.forEach(item => {
                    iterator += 1
                    const editable = item?.editable === true
                    const { items, id, ...shipmentFormData } = item || {}
                    delete shipmentFormData.editable

                    this.shipments.push({
                        shipmentFormData,
                        id,
                        items: Array.isArray(items) ? items : [],
                        iterator,
                        editable,
                    })
                })
            }
        },
        async showCOMEXFile() {
            if (this.request.attachedCOMEX) {
                const fileUrl = await openFile(
                    this.request.attachedCOMEX,
                    `${this.companyId}/purchases/${this.request.id}/AttachmentsCOMEX/COMEX`
                )
                setTimeout(async () => {
                    try {
                        const response = await fetch(fileUrl)
                        const blob = await response.blob()
                        const url = window.URL.createObjectURL(blob)
                        const link = document.createElement('a')
                        link.href = url
                        link.download =
                            `${this.request.attachedCOMEX}.pdf` || 'COMEX.pdf'
                        document.body.appendChild(link)
                        link.click()
                        document.body.removeChild(link)
                        window.URL.revokeObjectURL(url)
                    } catch (error) {
                        console.error('Error downloading COMEX:', error)
                        this.$toast.error('Error downloading file COMEX.')
                    }
                }, 1000)
            }
        },
        blobToFile(blob, fileName) {
            return new File([blob], fileName, {
                type: blob.type,
                lastModified: new Date().getTime(),
            })
        },
        async openImportFromForm() {
            try {
                this.loading = true
                this.purchasesForImport = await API.getPurchasesWithComex({})
                this.importFromForm = true
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        closeImportFromForm() {
            this.importFromForm = false
            this.importedInformation = null
            this.purchasesForImport = null
        },
        parseImportedComex(raw) {
            if (raw == null || raw === '') return []

            let parsed = raw
            if (typeof parsed === 'string') {
                try {
                    parsed = JSON.parse(parsed)
                } catch (error) {
                    return []
                }
            }

            if (typeof parsed === 'string') {
                try {
                    parsed = JSON.parse(parsed)
                } catch (error) {
                    return []
                }
            }

            if (Array.isArray(parsed)) {
                return parsed.map(item => {
                    if (typeof item === 'string') {
                        try {
                            return JSON.parse(item)
                        } catch (error) {
                            return {}
                        }
                    }
                    return item && typeof item === 'object' ? item : {}
                })
            }

            if (parsed && typeof parsed === 'object') {
                return Object.values(parsed).filter(
                    item => item && typeof item === 'object'
                )
            }

            return []
        },
        async importInformationProcess() {
            try {
                this.loading = true
                const importedComex = this.parseImportedComex(
                    this.importedInformation?.comex
                )

                const mappedComex = importedComex.map(item =>
                    this.mapImportedComexItem(item)
                )

                if (mappedComex.length === 0) {
                    this.$toast.error(
                        'The selected purchase has no invoice references to import.'
                    )
                    return
                }

                const currentComex = Array.isArray(this.request.comex)
                    ? this.request.comex
                    : []

                this.request = {
                    ...this.request,
                    comex: [...currentComex, ...mappedComex],
                }

                await this.getShipments()
                this.shipmentKey++

                await this.copyImportedComexFiles(
                    mappedComex,
                    this.importedInformation?.id
                )
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.closeImportFromForm()
                this.loading = false
            }
        },
        mapImportedComexItem(comexItem) {
            const migrated = this.migrateComexItemAttachments(comexItem || {})
            const fileNames = this.extractImportedFileNames(migrated)
            const skip = new Set([
                'id',
                'items',
                'editable',
                'totalWeight',
                'totalQuantity',
                'totalUSD',
                'totalCOP',
                'attachedInvoice',
                'attachedDIM',
                'attachedDocTransport',
                'attachedOtherFiles',
            ])
            const copied = {}
            Object.keys(migrated).forEach(key => {
                if (!skip.has(key)) copied[key] = migrated[key]
            })
            if (
                !copied.modality ||
                copied.modality === this.request.modality
            ) {
                delete copied.modality
            }

            return {
                ...copied,
                id: uuidv4(),
                items: [],
                editable: true,
                ...(fileNames.length > 0
                    ? { attachments: { files: fileNames } }
                    : {}),
            }
        },
        extractImportedFileNames(comexItem) {
            const names = new Set()
            const files = comexItem?.attachments?.files
            if (Array.isArray(files)) {
                files.forEach(file => {
                    const name =
                        typeof file === 'string' ? file : file?.name || ''
                    if (name) names.add(name)
                })
            }
            return [...names]
        },
        async copyImportedComexFiles(comexItems, sourcePurchaseId) {
            try {
                if (!sourcePurchaseId || !Array.isArray(comexItems)) return

                const destPath = `${this.companyId}/purchases/${this.request.id}/AttachmentsCOMEX/files`
                const sourcePaths = [
                    `${this.companyId}/purchases/${sourcePurchaseId}/AttachmentsCOMEX`,
                    `${this.companyId}/purchases/${sourcePurchaseId}/AttachmentsCOMEX/files`,
                ]
                const copiedNames = new Set()

                for (const item of comexItems) {
                    const fileNames = this.extractImportedFileNames(item)
                    for (const fileName of fileNames) {
                        if (!fileName || copiedNames.has(fileName)) continue
                        try {
                            let fileUrl = null
                            for (const path of sourcePaths) {
                                try {
                                    fileUrl = await storage()
                                        .ref(path)
                                        .child(fileName)
                                        .getDownloadURL()
                                    if (fileUrl) break
                                } catch (error) {
                                    if (
                                        error.code !==
                                        'storage/object-not-found'
                                    ) {
                                        console.warn(
                                            `Failed to locate imported file ${fileName}:`,
                                            error
                                        )
                                    }
                                }
                            }
                            if (!fileUrl) continue

                            const response = await fetch(fileUrl)
                            const blob = await response.blob()
                            const file = this.blobToFile(blob, fileName)
                            await saveFile(file, destPath)
                            copiedNames.add(fileName)
                        } catch (error) {
                            console.warn(
                                'Error copying imported file:',
                                fileName,
                                error
                            )
                        }
                    }
                }
            } catch (error) {
                console.warn('Error copying imported files:', error)
            }
        },
        calculatePrice(item) {
            let calculatedTotal = 0
            item.quotes = item.quotes ? item.quotes : []
            item.quotes.forEach(q => {
                if (q.able) {
                    calculatedTotal += Number(q.priceBeforeTRM ?? q.price ?? 0)
                }
            })
            return calculatedTotal
        },
        calculateItemTotal(item) {
            let calculatedTotal = 0
            item.quotes = item.quotes ? item.quotes : []
            item.quotes.forEach(q => {
                if (q.able) {
                    calculatedTotal +=
                        Number(item.quantity || 0) *
                        Number(q.priceBeforeTRM ?? q.price ?? 0)
                }
            })
            return calculatedTotal
        },
        calculateTotal() {
            let calculatedTotal = 0
            this.request.items = this.request.items ? this.request.items : []
            this.request.items.forEach(i => {
                i.quotes = i.quotes ? i.quotes : []
                i.quotes.forEach(q => {
                    if (q.able) {
                        calculatedTotal +=
                            Number(i.quantity || 0) *
                            Number(q.priceBeforeTRM ?? q.price ?? 0)
                    }
                })
            })
            return calculatedTotal
        },
        migrateComexItemAttachments(comexItem) {
            const cleanedItem = { ...comexItem }
            const fileNames = new Set()

            if (cleanedItem.attachments?.files) {
                cleanedItem.attachments.files.forEach(file => {
                    const name = typeof file === 'string' ? file : file?.name
                    if (name) fileNames.add(name)
                })
            }

            const legacyKeys = [
                'attachedInvoice',
                'attachedDIM',
                'attachedDocTransport',
                'attachedOtherFiles',
            ]
            legacyKeys.forEach(key => {
                if (Array.isArray(cleanedItem[key])) {
                    cleanedItem[key].forEach(name => fileNames.add(name))
                    delete cleanedItem[key]
                }
            })

            if (fileNames.size > 0) {
                cleanedItem.attachments = { files: [...fileNames] }
            } else {
                delete cleanedItem.attachments
            }

            return cleanedItem
        },
        async closeByCOMEX(request) {
            try {
                this.loading2 = true
                this.loading = true

                await API.updatePurchaseByComex({
                    closeByCOMEX: this.user.id,
                    id: request.id,
                })

                await API.closePurchaseByComex({
                    id: request.id,
                    notificationId: 'pFDh25EcR74EMiuypq8M',
                    ...(request.closingFile
                        ? { closingFile: request.closingFile.name }
                        : {}),
                })
                if (request.closingFile) {
                    await saveFile(
                        request.closingFile,
                        `${this.companyId}/purchases/${request.id}/closing`
                    )
                }
                this.$emit('finalize-comex', request.id)
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading2 = false
                this.loading = false
            }
        },
    },
}
</script>
<style>
.sticky-header {
    position: sticky;
    top: 0;
    z-index: 20;
    background-color: white;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}
</style>
